import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  createMainTrait,
  createMainTraitAPI,
  createProductTraitAPI,
  deleteMainTraitAPI,
  getTraitByIdAPI,
  getTraitsListingAPI,
  updateMainTraitAPI,
} from "../../redux/apis/traits";

export const getTraitListing = createAsyncThunk(
  "traits/getTraits",
  async (filters, { rejectWithValue }) => {
    try {
      const res = await getTraitsListingAPI(filters);
      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const addMainTrait = createAsyncThunk(
  "traits/addMainTrait",
  async (data, { rejectWithValue }) => {
    try {
      const res = await createMainTraitAPI(data);
      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const deleteMainTrait = createAsyncThunk(
  "traits/deleteTraits",
  async ({slug, platform}, { rejectWithValue }) => {
    try {
      const res = await deleteMainTraitAPI(slug, platform);
      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const getTraitById = createAsyncThunk(
  "trait/getTraitById",
  async ({slug, data}, { rejectWithValue }) => {
    try {
      const res = await getTraitByIdAPI(slug,data);
      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const updateMainTrait = createAsyncThunk(
  "trait/updateTrait",
  async ({data, slug, platform}, { rejectWithValue }) => {
    try {
      const res = await updateMainTraitAPI(data, slug, platform);
      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const createProductTrait = createAsyncThunk(
  "traits/addProductTrait",
  async (data, { rejectWithValue }) => {
    try {
      const res = await createProductTraitAPI(data);
      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

// export const deleteProductTraitAPI = createAsyncThunk(
//   "tra"
// )

const traitSlice = createSlice({
  name: "traits",
  initialState: {
    traits: [],
    traitDetails: {},
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getTraitListing.fulfilled, (state, action) => {
      state.loading = false; 
      state.traits = action.payload; 
      state.error = null;
      state.traitDetails= {};
    });

    builder.addCase(getTraitListing.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // Extra reducer for the pending action of fetchStores
    builder.addCase(getTraitListing.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(addMainTrait.fulfilled, (state, action) => {
      state.loading = false;
      state.addedTrait = action.payload; // Add the new trait to the traits list
      state.error = null;
    });

    builder.addCase(addMainTrait.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(addMainTrait.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(getTraitById.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(getTraitById.fulfilled, (state, action) => {
      state.loading = false;
      state.traitDetails = action.payload;
      state.error = null;
    });

    builder.addCase(getTraitById.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder
      .addCase(updateMainTrait.pending, (state, action) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateMainTrait.fulfilled, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateMainTrait.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const {} = traitSlice.actions;

export default traitSlice.reducer;
